import { createGlobalStyle } from "styled-components";

// TODO cleanup / remove everything that's not critical. Use SC instead.
export const GlobalPrintStyles = createGlobalStyle`
    @media print {
        h1 {
            color: #000;
            background: none;
        }

        h2, h3 {
            page-break-after: avoid;
        }

        nav, aside {
            display: none;
        }

        body {
            width: 100%;
            margin: 0;
            padding: 0;
        }

        img {
            max-width: 100% !important;
            display: block;
            width: 10cm;
            height: auto;
        }

        ul, img {
            page-break-inside: avoid;
        }

        @page {
            margin: 2cm;
        }
    }
`;
